//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import StakingCurrenciesExtra from './StakingCurrenciesExtra.vue';

import tableConfig from './tableConfig';

export default {
  components: { StakingCurrenciesExtra },

  data() {
    return {
      tableConfig,
      selection: [],
      searchString: '',
      loader: false,
      currentCurrencyId: 0,
      creatingStaking: {
        modal: false,
        input: {
          id: 0,
        },
      },
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('stakingCurrencies', ['page', 'pages', 'data', 'sort']),
    ...mapState('currencies', ['currencies']),

    preparedData() {
      const { data } = this;
      return data;
    },

    currentCurrency() {
      const { currentCurrencyId, preparedData } = this;
      return preparedData.find((e) => e.currencyId === currentCurrencyId);
    },

    noStakingCurrencyList() {
      const { currencies } = this;
      return currencies.filter((e) => !e.paraminingEn);
    },

    isCreatingStakingDisabled() {
      const { id } = this.creatingStaking.input;
      return !id;
    },
  },

  watch: {
    preparedData() {
      const { preparedData } = this;
      if (preparedData.length) {
        const { currencyId } = preparedData[0];
        this.currentCurrencyId = currencyId;
      }
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('stakingCurrencies', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
      editCurrencyAction: 'editCurrency',
      updateParaminingPercAction: 'updateParaminingPerc',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
      this.loader = false;
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    applySort(data) {
      this.setSortAction(data);
      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },

    setCurrentCurrency(currency) {
      this.currentCurrencyId = currency.currencyId;
    },

    createStaking() {
      this.creatingStaking.input.id = 0;
      this.creatingStaking.modal = true;
    },

    applyCreateStaking() {
      const { id } = this.creatingStaking.input;
      this.confirmAction({
        title: 'Are you sure you want to enable staking?',
        callback: async () => {
          const payload = {
            currencyId: id,
            paraminingEn: true,
          };
          this.setGeneralProgress(true);
          try {
            await this.editCurrencyAction(payload);
            this.loader = true;
            await this.loadDataAction({});
            this.loader = false;
            this.creatingStaking.modal = false;
            this.setSuccessNotification('Staking successfully enabled');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralProgress(false);
        },
      });
    },

    applyEditStaking(model) {
      this.confirmAction({
        title: 'Are you sure you want to edit staking settings?',
        hasPrompt: true,
        promptRequired: true,
        callback: async ({ prompt }) => {
          const {
            parataxEn,
            parataxPerc,
            parataxPercFix,
            paraminingMaxPerc,
            paraminingBeginTime,
          } = model;
          const editCurrencyPayload = {
            currencyId: this.currentCurrencyId,
            parataxEn,
            parataxPerc,
            parataxPercFix,
            paraminingMaxPerc,
            paraminingBeginTime,
            comment: prompt,
          };
          this.setGeneralProgress(true);
          try {
            await this.editCurrencyAction(editCurrencyPayload);
            this.loader = true;
            const { currentCurrencyId } = this;
            /* waiting for backend to apply the data */
            await new Promise((resolve) => setTimeout(resolve, 2000));
            await this.loadDataAction({});
            this.currentCurrencyId = currentCurrencyId;
            this.loader = false;
            this.setSuccessNotification('Staking settings successfully updated');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralProgress(false);
        },
      });
    },

    disableStaking() {
      this.confirmAction({
        title: 'Are you sure you want to disable staking?',
        hasPrompt: true,
        promptRequired: true,
        callback: async ({ prompt }) => {
          const { currentCurrencyId } = this;
          this.setGeneralProgress(true);
          this.loader = true;
          await this.editCurrencyAction({
            currencyId: currentCurrencyId,
            comment: prompt,
            paraminingEn: false,
          });
          await this.loadDataAction({});
          this.loader = false;
          this.setGeneralProgress(false);
          this.setSuccessNotification('Staking disabled');
        },
      });
    },

    getStakingPercMin(row) {
      const { stakingBalanceList } = row;
      const percList = stakingBalanceList.map((e) => e.perc);
      return Math.min.apply(null, percList);
    },

    getStakingPercMax(row) {
      const { stakingBalanceList } = row;
      const percList = stakingBalanceList.map((e) => e.perc);
      return Math.max.apply(null, percList);
    },
  },
};
